import React from "react";
import { clsx } from "clsx";
import { sanitize } from "isomorphic-dompurify";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";

import styles from "./Summary.module.css";

interface SummaryProps {
    className?: string;
    summary?: string;
    isPhoenix?: boolean;
    removeSummaryBottomMargin?: boolean;
}

export default function Summary({
    className,
    summary = "",
    isPhoenix,
    removeSummaryBottomMargin,
}: SummaryProps) {
    if (!summary?.length) return null;

    return (
        <section
            className={clsx(
                styles.summary,
                {
                    [typographyStyles.articleDek]: isPhoenix,
                    [styles.bottomMargin]: !removeSummaryBottomMargin,
                },
                className
            )}
            data-component="summary"
            dangerouslySetInnerHTML={{ __html: sanitize(summary) }}
        />
    );
}
